import numberWithCommas from 'common/util/numberWithCommas';

export const CommentCharacterLimit = 2500;

export enum CommentErrors {
  characterLimit = 'character_limit',
}

export const CommentErrorMessages = {
  [CommentErrors.characterLimit]: `Please make your comment between 1 and ${numberWithCommas(CommentCharacterLimit)} characters.`,
};
